import { defineMessages } from 'react-intl';

export const labels = defineMessages({
  actionLabel: {
    defaultMessage: 'Action',
    description: 'Label for selecting Action type'
  },
  fileTypeLabel: {
    defaultMessage: 'File Type',
    description: 'Label for selecting File type File Type'
  },
  actionExportLabel: {
    defaultMessage: 'Export',
    description: 'Button label for Export Action'
  },
  loadingLabel: {
    defaultMessage: 'Loading',
    description: 'label for Loading Action'
  },
  xlsFileTypeLabel: {
    defaultMessage: '.XLS',
    description: 'XLS File type Radio button label'
  },
  csvFileTypeLabel: {
    defaultMessage: '.CSV',
    description: 'CSV File type Radio button label'
  },
  pdfFileTypeLabel: {
    defaultMessage: '.PDF',
    description: 'PDF File type Radio button label'
  },
  actionArchiveLabel: {
    defaultMessage: 'Archive',
    description: 'Button label for Archive Action'
  },
  defaultDialogTitle: {
    defaultMessage: 'Export/Archive - Payments',
    description: 'Title for export/archive dialog'
  },
  defaultPDFFileTitle: {
    defaultMessage: 'TableReport :',
    description: 'Title in downloaded PDF File of Table data'
  },
  dismiss: {
    defaultMessage: 'Dismiss',
    description: 'Dismiss'
  }
});

export const messages = defineMessages({
  errorMessageForFileGeneration: {
    defaultMessage: '{fileType} file generation failed',
    description: 'Error message when the file generation fails'
  },
  errorMessageForArchive: {
    defaultMessage: 'Archive failed',
    description: 'Error message when the archive fails'
  },
  successMessageForArchive: {
    defaultMessage: 'Document successfully archived.',
    description: 'Success message when the archive is success'
  }
});

export const exportMessages = defineMessages({
  store: {
    defaultMessage: 'Store',
    description: 'Label for store '
  },
  documentTitle: {
    defaultMessage: ' Document Title',
    description: 'Label for document title '
  },
  dueOnOrBefore: {
    defaultMessage: 'Due On or Before',
    description: 'Label for due on or before'
  },
  paymentMethod: {
    defaultMessage: 'Payment Method',
    description: 'Label for payment method'
  },
  status: {
    defaultMessage: 'Status',
    description: 'Label for status'
  },
  total: {
    defaultMessage: 'Total',
    description: 'Label for total'
  },
  cibAccount: {
    defaultMessage: 'CIB Account',
    description: 'Label for cib account'
  },
  postingDescription: {
    defaultMessage: 'Posting Description',
    description: 'Label for posting description'
  },
  cashCompany: {
    defaultMessage: 'Cash Company',
    description: 'Label for cash company'
  },
  cashAccount: {
    defaultMessage: 'Cash Account',
    description: 'Label for cash account'
  },
  cashDisbursementsJournal: {
    defaultMessage: 'Cash Disbursements Journal',
    description: 'Label for Cash Disbursements Journal'
  },

  paymentDate: {
    defaultMessage: 'Payment Date',
    description: 'Label for payment date'
  },
  discount: {
    defaultMessage: 'Discount',
    description: 'Label for discount'
  },
  totalOwed: {
    defaultMessage: 'Total Owed',
    description: 'Label for total owed'
  },
  selectedTotal: {
    defaultMessage: 'Selected Total',
    description: 'Label for selected total'
  },
  pending: {
    defaultMessage: 'Pending',
    description: 'Label for rending'
  },
  settled: {
    defaultMessage: 'Settled',
    description: 'Label for settled'
  },
  voided: {
    defaultMessage: 'Voided',
    description: 'Label for voided'
  },
  reconciled: {
    defaultMessage: 'Reconciled',
    description: 'Label for reconciled'
  }
});
